import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import {
  getDefaultWallets,
  RainbowKitProvider,
  darkTheme,
} from "@rainbow-me/rainbowkit";
import "@rainbow-me/rainbowkit/styles.css";
import { configureChains, createConfig, WagmiConfig } from "wagmi";
import { jsonRpcProvider } from "wagmi/providers/jsonRpc";

const railsTestnet = {
  id: 24116,
  name: "Rails Testnet",
  network: "rails-testnet",
  nativeCurrency: { name: "Rails Testnet Marker", symbol: "STEAMX", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://testnet.steamexchange.io"] },
  },
  blockExplorers: {
    default: { name: "Rails Testnet Explorer", url: "https://testnet.steamexchange.io" },
  },
  testnet: true,
};

const railsMainnet = {
  id: 6278,
  name: "Rails Mainnet",
  network: "rails-mainnet",
  nativeCurrency: { name: "Rails Mainnet Marker", symbol: "STEAMX", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://mainnet.steamexchange.io"] },
  },
  blockExplorers: {
    default: { name: "Rails Explorer", url: "https://mainnet.steamexchange.io" },
  },
};

const chains = [railsMainnet, railsTestnet];
const projectId = "a9680cd05c410ced5a6621e943754fc8";

const { connectors } = getDefaultWallets({
  appName: "Rails Launchpad",
  chains,
  projectId,
});

const { publicClient } = configureChains(chains, [
  jsonRpcProvider({
    rpc: (chain) => ({
      http: chain.rpcUrls.default.http[0],
    }),
  }),
]);
const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <WagmiConfig config={wagmiConfig}>
      <RainbowKitProvider chains={chains} theme={darkTheme()}>
        <App />
      </RainbowKitProvider>
    </WagmiConfig>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
